import { Box, DialogContent, Grid, MenuItem, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import {
  CustomButton,
  CustomSelect,
  CustomTextArea,
  HorizontalForm,
} from '../../../../../common/components';

const ReleaseTab = ({
  localContract,
  handleInputChange,
  handleSelectChange,
  handleReleaseContract,
  releaseReasons,
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <DialogContent>
        <Box sx={{ width: '100%' }}>
          <Grid container justifyContent="center" alignItems="center">
            <Box sx={{ width: '100%', maxWidth: '800px' }}>
              <Box
                sx={{
                  borderRadius: 2,
                }}
              >
                <HorizontalForm withBorder={false} sx={{ p: 1 }}>
                  <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <CustomSelect
                      name="uuid_release_reason"
                      label="Motivo de Liberación"
                      value={
                        localContract.uuid_release_reason !== 'None'
                          ? localContract.uuid_release_reason
                          : ''
                      }
                      onChange={handleSelectChange}
                      required
                      fullWidth
                    >
                      <MenuItem value="">Seleccionar motivo</MenuItem>
                      {releaseReasons.map((rr) => (
                        <MenuItem key={rr.uuid} value={rr.uuid}>
                          {rr.description}
                        </MenuItem>
                      ))}
                    </CustomSelect>
                  </Box>
                </HorizontalForm>

                <HorizontalForm withBorder={false} sx={{ p: 1, pt: 0 }}>
                  <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <CustomTextArea
                      name="release_reason_obs"
                      label="Observaciones"
                      value={localContract.release_reason_obs || ''}
                      onChange={handleInputChange}
                      placeholder="Ingrese observaciones adicionales sobre la liberación del contrato..."
                      rows={4}
                      fullWidth
                    />
                  </Box>
                </HorizontalForm>

                <Box
                  sx={{
                    mt: 1,
                    p: 2,
                    backgroundColor: '#fff3cd',
                    border: '1px solid #ffeaa7',
                    borderRadius: 1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                  }}
                >
                  <WarningIcon sx={{ color: '#856404' }} />
                  <Typography variant="body2" sx={{ color: '#856404', fontWeight: 'medium' }}>
                    <strong>Atención:</strong> Esta acción liberará el contrato y lo moverá a la
                    sección de contratos archivados. Esta acción no se puede deshacer.
                  </Typography>
                </Box>

                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
                  <CustomButton
                    variant="danger"
                    onClick={handleReleaseContract}
                    buttonIcon={WarningIcon}
                    disabled={
                      !localContract.uuid_release_reason ||
                      localContract.uuid_release_reason === 'None'
                    }
                    iconProps={{ size: 'small' }}
                  >
                    Liberar Contrato
                  </CustomButton>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Box>
      </DialogContent>
    </Box>
  );
};

export default ReleaseTab;
